import React from "react";
import { useDispatch } from "react-redux";

import { hideModal } from "../../../../../../store/slices/modal";

const LoadDeleteModal = ({ modalData }) => {
  const { id, title, typeOfLoad, loadPostContextDispatch } = modalData;
  const dispatch = useDispatch();

  const closeModal = () => dispatch(hideModal());

  const deleteLoad = () => {
    if (typeOfLoad === "Pallet") {
      loadPostContextDispatch({
        type: "REMOVE_PALLET_LOADER_FROM_LIST",
        payload: id,
      });
    } else if (typeOfLoad === "Barrel") {
      loadPostContextDispatch({
        type: "REMOVE_BARREL_LOADER_FROM_LIST",
        payload: id,
      });
    } else if (typeOfLoad === "Stones") {
      loadPostContextDispatch({
        type: "REMOVE_STONES_LOADER_FROM_LIST",
        payload: id,
      });
    } else if (typeOfLoad === "Sand") {
      loadPostContextDispatch({
        type: "REMOVE_SAND_LOADER_FROM_LIST",
        payload: id,
      });
    } else if (typeOfLoad === "Laterite") {
      loadPostContextDispatch({
        type: "REMOVE_LATERITE_LOADER_FROM_LIST",
        payload: id,
      });
    } else if (typeOfLoad === "Vehicle") {
      loadPostContextDispatch({
        type: "REMOVE_VEHICLE_LOADER_FROM_LIST",
        payload: id,
      });
    }

    closeModal();
  };

  return (
    <div className="col-xl-4 col-lg-6 col-md-7 col-sm-10">
      <div className="alert-modal">
        <p>
          Are you sure you want to remove "{title}" {typeOfLoad} load?
        </p>

        <div className="multiple-btn modal-button">
          <button onClick={deleteLoad}> Yes </button>
          <button onClick={closeModal}> No </button>
        </div>
      </div>
    </div>
  );
};

export default React.memo(LoadDeleteModal);
